<template>
    <app-modal-wrapper>
        <form @submit.prevent="sendElevator" class="modal-elevator-send">
            <div class="modal-elevator-send__content">
                <div class="elevator-send__form">
                    <h4>{{ $t('confirm.elevator.send') }}</h4>
                    <app-base-select
                        :label="$t('elevators.elevator.floor.ph')"
                        :place-holder="$t('elevators.elevator.floor.ph')"
                        :selected-option="selectedFloor"
                        :options="floors"
                        :type="'text'"
                        @select="selectFloor"
                    />
                </div>
            </div>
            <div class="modal-elevator-send__control">
                <app-base-btn
                    :size="'full'"
                    :variation="'cancel'"
                    :text="$t('common.buttons.cancel')"
                    @action="closeModalElevatorSend"
                />
                <app-base-btn
                    :type="'submit'"
                    :size="'full'"
                    :variation="'save'"
                    :text="$t('common.buttons.sendEl')"
                />
            </div>
            <div v-if="isLoaded" class="modal-elevator-send__loader">
                <app-loader
                    :size="'large'"
                />
            </div>
        </form>
    </app-modal-wrapper>
</template>

<script>
    import { greenHubAPI } from "../../../config/api";
    import { elevatorsToastsMixin } from "../../../mixins/toasts/elevators";
    import { elevatorFloors } from "../../../constants/elevators";

    export default {
        name: "ModalElevatorSend",

        props: {
            selectedElevator: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                isLoaded: false,
                selectedFloor: null
            }
        },

        mixins: [ elevatorsToastsMixin ],

        created() {
            this.selectedFloor = this.floors[0];
        },

        computed: {
            floors() {
                return elevatorFloors;
            }
        },

        methods: {
            sendElevator() {
                this.isLoaded = true;

                const id = this.selectedElevator.id;

                const floorToSend = {
                    floor: this.selectedFloor.id
                }

                greenHubAPI.post(`/elevators/${id}/floor`, floorToSend)
                    .then(() => {
                        this.showElevatorSendToast();
                        this.closeModalElevatorSend();
                    })
                    .catch(() => {
                        this.showElevatorCommandError();
                    })
                    .finally(() => {
                        this.isLoaded = false;
                    })
            },

            selectFloor(floor) {
                this.selectedFloor = floor;
            },

            closeModalElevatorSend() {
                this.closeModal('modalElevatorSend');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modal-elevator-send {
        background: var(--system-white);
        padding: 30px;
        display: flex;
        flex-direction: column;
        max-width: 574px;
        width: 100%;

        h4 {
            margin-bottom: 30px;
        }

        &__control {
            display: flex;
            margin-top: 45px;

            button:first-child {
                margin-right: 30px;
            }
        }

        &__loader {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background: var(--app-base-primary-10);
        }
    }
</style>